import * as classnames from 'classnames';

export const CLASS_PREFIX = 'elc-';
export const JS_PREFIX = 'js-';

const formatClass = (name: string) => `${CLASS_PREFIX}${name}`;
const formatJs = (name: string) => `${JS_PREFIX}${name}`;

type ClassValue = string | number | ClassDictionary | ClassArray | undefined | null | false;

interface ClassDictionary {
    [id: string]: boolean | undefined | null;
}

// eslint-disable-next-line
interface ClassArray extends Array<ClassValue> {
    // empty
}

export const classes = (name: string, ...rest: ClassValue[]) =>
    classnames(formatClass(name), formatJs(name), ...rest);
